
import React from 'react';
 
const EnvContext = React.createContext(null);
 
export default EnvContext;